module.exports = __webpack_public_path__ + "static/nav-next.abb8b984.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nav-next.jpg
// module id = 544
// module chunks = 168707334958949